import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import Form, { FormTextField, FormImageUploader } from '@ts-core/core/components/FormV2';

import { useAcademyActions } from '../../hooks';
import { transformAcademyToFormInput } from '../../utils';
import { Academy } from '../../types';
import { AcademyFormInput } from '../../types/form';

interface AcademyFormProps {
  academy: Academy;

  onAcademySaved: () => void;
}

const AcademyForm = (props: AcademyFormProps) => {
  const { academy, onAcademySaved } = props;
  const { onUpdateAcademy, updateAcademyLoading, updateAcademyError } = useAcademyActions();

  const { handleSubmit, formState, control } = useForm<AcademyFormInput>({ defaultValues: transformAcademyToFormInput(academy) });

  const handleSaveAcademy = useCallback(
    (input: AcademyFormInput) => {
      onUpdateAcademy(input, onAcademySaved);
    },
    [onUpdateAcademy, onAcademySaved]
  );

  return (
    <Form
      sx={{ width: '100%' }}
      onSubmit={handleSubmit(handleSaveAcademy)}
      formState={formState}
      isSubmitting={updateAcademyLoading}
      submitError={updateAcademyError}
    >
      <FormTextField control={control} label="Nombre" name="name" fullWidth />
      <FormImageUploader sx={{ mt: 2 }} control={control} name="logoImagePath" imageType="academy" imageUrl={academy?.logoImageUrl} />
    </Form>
  );
};

export default AcademyForm;
